module.exports = __webpack_public_path__ + "img/user-face.199b534c.png";